export default "__VITE_ASSET__6999b7c6__"